// All .pill-* class names used here exist in src/styles/decision-brief.css.
// Verified: pill-green, pill-steel, pill-amber, pill-navy, pill-red are all present.

export interface AgentStatusPillProps {
  status:
    | 'active'
    | 'inactive'
    | 'paused'
    | 'deprecated'
    | 'draft'
    | 'archived'
    | 'running'
    | 'completed'
    | 'failed';
}

const STATUS_LABELS: Record<AgentStatusPillProps['status'], string> = {
  active:     'Активен',
  inactive:   'Неактивен',
  paused:     'Приостановлен',
  deprecated: 'Устарел',
  draft:      'Черновик',
  archived:   'В архиве',
  running:    'Выполняется',
  completed:  'Завершён',
  failed:     'Ошибка',
};

const STATUS_PILL_CLASS: Record<AgentStatusPillProps['status'], string> = {
  active:     'pill pill-green',
  inactive:   'pill pill-steel',
  paused:     'pill pill-amber',
  deprecated: 'pill pill-steel',
  draft:      'pill pill-amber',
  archived:   'pill pill-steel',
  running:    'pill pill-navy',
  completed:  'pill pill-green',
  failed:     'pill pill-red',
};

export function AgentStatusPill({ status }: AgentStatusPillProps) {
  return (
    <span className={STATUS_PILL_CLASS[status]}>
      {STATUS_LABELS[status]}
    </span>
  );
}
